import React from 'react';
import ContentLoader from 'react-content-loader';
import { Box } from '@mui/material';


const BoardSkeleton = ({
    numberOfLists = 4,
    tasksPerList = 7,
    listWidth = 300,
    listHeight = 700,
    backgroundColor = "#3D393B",
    foregroundColor = "#4A494B"
}) => (
    <div className="project-page-skeleton" style={{ display: 'flex', gap: '16px', padding: '16px' }}>
        {[...Array(numberOfLists)].map((_, index) => (
            <Box
                key={index}
                style={{ backgroundColor: "#252224", borderRadius: "10px", padding: "8px", marginRight:"36px", marginTop:"-6px", marginLeft:"10px" }}
            >
                <ContentLoader
                    speed={2}
                    width={listWidth}
                    height={listHeight}
                    viewBox={`0 0 ${listWidth} ${listHeight}`}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                    style={{ width: '280px' }}
                >
                    {/* List header */}
                    <rect x="10" y="0" rx="4" ry="4" width="200" height="18" />
                    <rect x="265" y="0" rx="4" ry="4" width="24" height="18" />

                    <rect x="20" y="50" rx="8" ry="8" width="270" height="130" />

                    {/* Tasks */}
                    {[...Array(tasksPerList)].map((_, taskIndex) => (
                        <rect key={taskIndex} x="25" y={200 + taskIndex * 60} rx="8" ry="8" width="250" height="50" />
                    ))}

                    {/* Add task button */}
                    <rect x="120" y={220 + tasksPerList * 60} rx="4" ry="4" width="150" height="24" />
                </ContentLoader>
            </Box>
        ))}
    </div>
);




export default BoardSkeleton;
